import { render, staticRenderFns } from "./PullNewBlock.vue?vue&type=template&id=74d8ab82&lang=html"
import script from "./PullNewBlock.vue?vue&type=script&lang=js"
export * from "./PullNewBlock.vue?vue&type=script&lang=js"
import style0 from "./PullNewBlock.vue?vue&type=style&index=0&id=74d8ab82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports